import React from "react";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import ValidCheckTab, {
  validCheckTabState,
} from "../../components/pages/Manage/ValidCheck/ValidCheckTab";
import { useRecoilValue } from "recoil";
import LoginCheck from "./LoginCheck";
import ReportPartyListSection from "../../components/pages/Manage/LoginCheck/ReportPartyListSection";

export default function ManageValidCheck() {
  const validCheckTab = useRecoilValue(validCheckTabState);

  return (
    <>
      <PageTitle title="유효성 체크" />

      <ValidCheckTab />

      {validCheckTab === 0 ? (
        // 유효성 체크 관리
        <LoginCheck />
      ) : (
        // 신고된 관리
        <ReportPartyListSection />
      )}
    </>
  );
}
